import { Box, Switch, Typography } from "@mui/material";
import React from "react";

import SectionWrapper from "../../../section-wrapper";
import SectionActions from "../../section-actions";
import useSupervisorAppController from "./controllers/use-supervisor-app-controller";

interface ISupervisorAppSettingsProps {
	companyId: number;
}

const SupervisorAppSettings: React.FC<ISupervisorAppSettingsProps> = ({ companyId }) => {
	const [
		{ supervisorAppSettings, newSupervisorAppSettings, loading, getCompanySettingsStatus },
		{ setNewSupervisorAppSettings, handleSave },
	] = useSupervisorAppController(companyId);

	return (
		<SectionWrapper
			title='Supervisor app settings'
			subtitle='Supervisor mobile app settings at company level.'
		>
			<Box
				sx={{
					backgroundColor: "#F5F5F5",
					borderRadius: "8px",
					marginTop: "32px",
					marginBottom: "16px",
					padding: "16px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<Typography
							sx={{
								fontFamily: "Roboto",
								fontWeight: 400,
								fontSize: "16px",
								color: "rgba(0, 0, 0, 0.87)",
							}}
						>
							Supervisor - mobile app enabled
						</Typography>
						<Typography
							sx={{
								fontFamily: "Roboto",
								fontWeight: 400,
								fontSize: "12px",
								color: "rgba(0, 0, 0, 0.6)",
							}}
						>
							Supervisors can login to the mobile app.
						</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Switch
							checked={newSupervisorAppSettings?.supervisorAppEnabled ?? false}
							onChange={(e) =>
								setNewSupervisorAppSettings((pre: any) => ({
									...pre,
									supervisorAppEnabled: e.target.checked,
								}))
							}
						/>
					</Box>
				</Box>
				{/* AI features toggle — not being released this time. Re-enable when ready.
				{newSupervisorAppSettings?.supervisorAppEnabled ? (
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "space-between",
							marginTop: "20px",
						}}
					>
						<Box sx={{ display: "flex", flexDirection: "column" }}>
							<Typography
								sx={{
									fontFamily: "Roboto",
									fontWeight: 400,
									fontSize: "16px",
									color: "rgba(0, 0, 0, 0.87)",
								}}
							>
								AI features enabled
							</Typography>
							<Typography
								sx={{
									fontFamily: "Roboto",
									fontWeight: 400,
									fontSize: "12px",
									color: "rgba(0, 0, 0, 0.6)",
								}}
							>
								Once enabled, AI features are available to supervisors in the
								mobile app.
							</Typography>
						</Box>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Switch
								checked={newSupervisorAppSettings?.aiFeaturesEnabled ?? false}
								onChange={(e) =>
									setNewSupervisorAppSettings((pre: any) => ({
										...pre,
										aiFeaturesEnabled: e.target.checked,
									}))
								}
							/>
						</Box>
					</Box>
				) : null}
				*/}
			</Box>
			<SectionActions
				oldData={supervisorAppSettings}
				newData={newSupervisorAppSettings}
				resetChanges={() => setNewSupervisorAppSettings(supervisorAppSettings)}
				handleSave={handleSave}
				status={getCompanySettingsStatus}
				loading={loading}
			/>
		</SectionWrapper>
	);
};

export default SupervisorAppSettings;
